module.exports = __webpack_public_path__ + "static/media/wifi-1.c94034a6.svg";